import { render, staticRenderFns } from "./OfferLandings.vue?vue&type=template&id=0013bc0e&scoped=true"
import script from "./OfferLandings.vue?vue&type=script&lang=ts"
export * from "./OfferLandings.vue?vue&type=script&lang=ts"
import style0 from "./OfferLandings.vue?vue&type=style&index=0&id=0013bc0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013bc0e",
  null
  
)

export default component.exports